"use client"

import { ArrowLeft, Calendar, FileText, FileType2, Hash, Loader2, User } from 'lucide-react'
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import axiosInstance from "../utils/axiosInstance"

export default function ViewLoanNote() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [loanNote, setLoanNote] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchLoanNote = async () => {
      try {
        const response = await axiosInstance.get(`/loan/loans/notesById/${id}`)
        setLoanNote(response.data.data)
      } catch (error) {
        console.error("Error fetching loan note:", error)
      } finally {
        setLoading(false)
      }
    }

    fetchLoanNote()
  }, [id])

  if (loading) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-gray-500" />
      </div>
    )
  }

  if (!loanNote) {
    return (
      <div className="flex min-h-[400px] flex-col items-center justify-center gap-2 text-red-500">
        <FileType2 className="h-8 w-8" />
        <p className="text-lg font-medium">Loan note not found</p>
      </div>
    )
  }

  return (
    <div className="mx-auto  px-4 py-8">
      <div className="mb-8 flex items-center justify-between">
        <h1 className="text-2xl font-bold tracking-tight">Loan Note Details</h1>
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 rounded-lg border bg-white px-4 py-2 text-sm font-medium shadow-sm transition-colors hover:bg-gray-50"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </button>
      </div>

      <div className="overflow-hidden rounded-xl border bg-white shadow">
        <div className="grid gap-6 border-b p-6">
          <div className="grid gap-1">
            <div className="text-sm text-gray-500">Note ID</div>
            <div className="inline-flex items-center gap-2 font-medium">
              <Hash className="h-4 w-4 text-gray-400" />
              {loanNote.id}
            </div>
          </div>

          <div className="grid gap-1">
            <div className="text-sm text-gray-500">Application ID</div>
            <div className="inline-flex items-center gap-2 font-medium">
              <FileText className="h-4 w-4 text-gray-400" />
              {loanNote.userLoanApplicationId}
            </div>
          </div>

          <div className="grid gap-1">
            <div className="text-sm text-gray-500">Created By</div>
            <div className="inline-flex items-center gap-2 font-medium">
              <User className="h-4 w-4 text-gray-400" />
              User {loanNote.createdBy}
            </div>
          </div>

          <div className="grid gap-1">
            <div className="text-sm text-gray-500">Created At</div>
            <div className="inline-flex items-center gap-2 font-medium">
              <Calendar className="h-4 w-4 text-gray-400" />
              {new Date(loanNote.createdAt).toLocaleString()}
            </div>
          </div>

          <div className="grid gap-1">
            <div className="text-sm text-gray-500">Note</div>
            <div className="rounded-lg bg-gray-50 p-4">{loanNote.note}</div>
          </div>
        </div>

        <div className="p-6">
          <div className="mb-4 text-sm text-gray-500">Documents</div>
          <div className="grid gap-4 sm:grid-cols-2">
            {loanNote.documents.map((doc, index) => (
              <a
                key={index}
                href={doc.documentUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-4 rounded-lg border bg-gray-50 p-4 transition-colors hover:bg-gray-100"
              >
                <FileType2 className="h-8 w-8 text-gray-400" />
                <div className="grid gap-1">
                  <div className="font-medium capitalize">{doc.documentType}</div>
                  <div className="text-sm text-gray-500">View Document</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

